export const COOKIE_CONSENT_STORAGE_KEY = 'CookieConsent';
export const COOKIE_CONSENT_TOAST_ID = 'cookie-consent';
